export const dramaInfo = {
  title: "善良的小姨子",
  englishTitle: "The Kind Sister-in-Law",
  year: 2026,
  region: "韩国",
  genre: "家庭 / 情感 / 都市",
  rating: 8.6,
  totalEpisodes: 24,
  updatedEpisodes: 18,
  status: "更新中",
  updateSchedule: "每周三、周五 20:00 更新 2 集",
  tagline: "一场关于亲情、误解与守护的温情故事，在都市烟火里慢慢展开。",
  cover:
    "https://readdy.ai/api/search-image?query=cinematic%20elegant%20portrait%20poster%20of%20a%20refined%20young%20woman%20in%20soft%20cream%20dress%20standing%20in%20warm%20golden%20backlight%2C%20blurred%20romantic%20interior%20background%2C%20gentle%20serene%20expression%2C%20korean%20drama%20poster%20aesthetic%2C%20moody%20warm%20amber%20tones%2C%20professional%20photography%2C%20high%20detail%2C%20subtle%20film%20grain&width=800&height=1200&seq=poster-main-drama&orientation=portrait",
  backdrop:
    "https://readdy.ai/api/search-image?query=cinematic%20golden%20hour%20scene%20of%20an%20elegant%20young%20woman%20in%20a%20soft%20cream%20dress%20standing%20by%20a%20sunlit%20window%20with%20sheer%20curtains%2C%20warm%20amber%20and%20teal%20color%20grading%2C%20romantic%20korean%20drama%20film%20still%2C%20soft%20dramatic%20lighting%2C%20moody%20atmosphere%2C%20professional%20cinematography%2C%20subtle%20film%20grain%2C%20blurred%20bokeh%20foreground%2C%20high%20detail&width=1920&height=1080&seq=hero-drama-01&orientation=landscape",
  synopsis:
    "林家的老宅迎来了一位特别的家人——善良温柔的小姨子秀雅。她用一腔真诚打点着这个家庭的一日三餐，也在琐碎日常里悄然化解着兄妹之间的心结。当误会与旧事被逐一揭开，这个家在她的守护下重新找回了温度。",
  synopsisFull:
    "《善良的小姨子》以都市家庭为背景，讲述了温柔坚韧的秀雅在姐姐意外离世后，独自走进林家照顾年迈的外婆与年幼的外甥，用日复一日的体贴与真诚化解家庭裂痕的故事。剧中既有厨房与餐桌间的烟火温情，也有兄妹之间因误解而生的隔阂与和解。随着旧信中一段被尘封的往事浮出水面，秀雅不得不面对自己与这个家庭之间微妙的牵绊。全剧以细腻的笔触描摹亲情的重量，在现实的困境里寻找善意与光亮，温暖而克制，是一部值得细细品味的家庭情感剧。",
  tags: ["家庭情感", "都市生活", "治愈系", "温情", "豆瓣高分"],
};

export const heroSlides = [
  {
    id: "slide-1",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20golden%20hour%20scene%20of%20an%20elegant%20young%20woman%20in%20a%20soft%20cream%20dress%20standing%20by%20a%20sunlit%20window%20with%20sheer%20curtains%2C%20warm%20amber%20and%20teal%20color%20grading%2C%20romantic%20korean%20drama%20film%20still%2C%20soft%20dramatic%20lighting%2C%20moody%20atmosphere%2C%20professional%20cinematography%2C%20subtle%20film%20grain%2C%20blurred%20bokeh%20foreground%2C%20high%20detail&width=1920&height=1080&seq=hero-drama-01&orientation=landscape",
    badge: "最新更新至 第18集",
    title: "善良的小姨子",
    subtitle: "用善意点亮一个家的烟火日常",
    episodeNumber: 18,
  },
  {
    id: "slide-2",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20night%20city%20street%20scene%20with%20warm%20streetlights%2C%20an%20elegant%20woman%20in%20a%20beige%20coat%20walking%20alone%2C%20reflections%20on%20wet%20pavement%2C%20romantic%20korean%20drama%20film%20still%2C%20warm%20amber%20color%20grading%2C%20moody%20cinematic%20atmosphere%2C%20professional%20cinematography%2C%20high%20detail%2C%20subtle%20film%20grain&width=1920&height=1080&seq=hero-drama-02&orientation=landscape",
    badge: "本周热播",
    title: "第17集 · 雨夜的告白",
    subtitle: "有些话说出口，就不再是秘密",
    episodeNumber: 17,
  },
  {
    id: "slide-3",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20cozy%20living%20room%20scene%20at%20dusk%20with%20warm%20lamp%20light%2C%20a%20family%20gathering%20around%20a%20wooden%20dining%20table%2C%20soft%20long%20shadows%2C%20korean%20drama%20film%20still%2C%20warm%20amber%20and%20brown%20tones%2C%20emotional%20tender%20mood%2C%20professional%20cinematography%2C%20high%20detail%2C%20subtle%20film%20grain&width=1920&height=1080&seq=hero-drama-03&orientation=landscape",
    badge: "高口碑家庭剧",
    title: "第16集 · 餐桌上的和解",
    subtitle: "一餐饭的温度，能融化很多心事",
    episodeNumber: 16,
  },
];

export const timelineEvents = [
  {
    id: "tl-1",
    stage: "第一幕 · 初入林家",
    episodes: "第1 - 4集",
    title: "陌生的新家人",
    summary:
      "秀雅带着简单的行李走进林家老宅，面对疏离的兄妹与年幼的外甥，她选择用一顿热乎的晚饭打开了这个家的第一道门。",
  },
  {
    id: "tl-2",
    stage: "第二幕 · 日常的磨合",
    episodes: "第5 - 9集",
    title: "灶台边的温柔",
    summary:
      "从照顾外婆的三餐到接送外甥上学，秀雅在细碎的日常里慢慢被这个家接纳，也第一次听说了姐姐当年离开的隐情。",
  },
  {
    id: "tl-3",
    stage: "第三幕 · 误会的漩涡",
    episodes: "第10 - 14集",
    title: "被误解的善意",
    summary:
      "邻居的闲言与旧照片的曝光让秀雅陷入流言，她一度想要离开，却在雨夜里被赶来的家人紧紧拉住。",
  },
  {
    id: "tl-4",
    stage: "第四幕 · 尘封的信",
    episodes: "第15 - 18集",
    title: "真相浮出水面",
    summary:
      "一封姐姐留下的旧信被找到，信中交代了当年的无奈与托付，兄妹之间的隔阂在泪水与拥抱中终于化解。",
  },
  {
    id: "tl-5",
    stage: "终章 · 团圆的餐桌",
    episodes: "第19 - 24集",
    title: "一家人，一个家",
    summary:
      "秀雅正式成为这个家的一员，老宅的餐桌上重新摆满了热闹的饭菜。故事在温暖的烟火气里落下帷幕。",
  },
];

export default dramaInfo;